import { useState } from 'react'
import { trackEvent } from '../analytics'
import { BOOKING_URL, BRAND, FIELD_NOTES_LINK, MENU, NAV_CTA, NAV_LINKS, VIDEOS } from '../data/content'
import Mark from './Mark'

export default function Nav() {
  const [open, setOpen] = useState(false)
  const links = VIDEOS.length > 0
    ? [NAV_LINKS[0], NAV_LINKS[1], NAV_LINKS[2], FIELD_NOTES_LINK, NAV_LINKS[3]]
    : NAV_LINKS

  return (
    <header className="nav">
      <div className="nav-in container">
        <a className="nav-brand" href="/">
          <Mark />
          <span>{BRAND}</span>
        </a>

        <nav className="nav-links" aria-label="Primary">
          {links.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <a
          className="btn btn-primary nav-cta"
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('booking_click', { location: 'nav' })}
        >
          {NAV_CTA}
        </a>

        <button
          type="button"
          className="nav-toggle"
          aria-label={open ? MENU.close : MENU.open}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? (
            <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
              <path d="M5 5 L17 17 M17 5 L5 17" stroke="currentColor" strokeWidth="1.5" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
              <path d="M3 6 H19 M3 11 H19 M3 16 H19" stroke="currentColor" strokeWidth="1.5" />
            </svg>
          )}
        </button>
      </div>

      {open && (
        <div className="nav-mobile">
          <nav className="nav-mobile-links" aria-label="Primary">
            {links.map((link) => (
              <a key={link.href} href={link.href} onClick={() => setOpen(false)}>
                {link.label}
              </a>
            ))}
          </nav>
          <a
            className="btn btn-primary"
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('booking_click', { location: 'nav' })}
          >
            {NAV_CTA}
          </a>
        </div>
      )}
    </header>
  )
}
